import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import { Icon, Menu } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import { LinkTarget } from '../../typings/common';
import { GridAction, GridActionItem, GridActionItems, GridActionItemType } from '../../typings/grid';
import { MinusPhraseItemsActions } from '../../typings/minusPhraseLibrary';
import { PhrasesSelectorStartPhrasesActions } from '../../typings/phrases';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { ScopedPopup } from '../ScopedPopup/ScopedPopup';

import './ActionsMenuDropdown.css';
import * as keyset from './ActionsMenuDropdown.i18n';

const i18n = i18nFactory(keyset);

export enum ActionsMenuDropdownStatus {
    normal = 'normal',
    progress = 'progress',
    disabled = 'disabled'
}

// todo @mrronuar Отвязать компонент от грида, сделать абстрактные интерфейсы DIRECT-104554
export interface ActionsMenuDropdownProps {
    actions: GridActionItems;
    onActionClick: (
        type: GridActionItemType,
        action: GridAction | MinusPhraseItemsActions | PhrasesSelectorStartPhrasesActions,
        target?: LinkTarget
    ) => void;
    status: ActionsMenuDropdownStatus;
    isCompactViewEnabled?: boolean;
}

export interface ActionsMenuDropdownState {
    isActionsSelectorOpened: boolean;
}

const BLOCK = 'actions-menu-dropdown';

export class ActionsMenuDropdown extends React.Component<ActionsMenuDropdownProps, ActionsMenuDropdownState> {
    constructor(props: ActionsMenuDropdownProps) {
        super(props);

        this.state = {
            isActionsSelectorOpened: false
        };
    }

    shouldComponentUpdate(nextProps: ActionsMenuDropdownProps, nextState: ActionsMenuDropdownState) {
        return (
            nextProps.actions !== this.props.actions ||
            nextProps.status !== this.props.status ||
            nextProps.isCompactViewEnabled !== this.props.isCompactViewEnabled ||
            nextState.isActionsSelectorOpened !== this.state.isActionsSelectorOpened
        );
    }

    render() {
        const { actions, status, isCompactViewEnabled } = this.props;
        const { isActionsSelectorOpened } = this.state;

        return (
            <>
                <ButtonDecorator
                    theme="action"
                    view="default"
                    tone="default"
                    size={isCompactViewEnabled ? 's' : 'n'}
                    iconRight={
                        <Icon size={'n'} type={'arrow'} direction={isActionsSelectorOpened ? 'top' : 'bottom'} />
                    }
                    progress={status === 'progress'}
                    cls={classNames(Bem.cls(BLOCK), TestBem.cls(BLOCK))}
                    onClick={this.onActionsSelectorBtnClick}
                    disabled={status === 'progress' || status === 'disabled'}
                >
                    {i18n('action')}
                </ButtonDecorator>
                <ScopedPopup
                    theme="normal"
                    target={'anchor'}
                    mix={{ block: BLOCK, elem: 'popup' }}
                    directions={['bottom-left', 'right-bottom']}
                    anchor={this}
                    autoclosable={true}
                    visible={isActionsSelectorOpened}
                    onOutsideClick={this.onActionsSelectorOutsideClick}
                >
                    <Menu
                        cls={classNames(Bem.cls(BLOCK, 'menu'), TestBem.cls(BLOCK, 'menu'))}
                        theme="normal"
                        size="m"
                        type="radio"
                        onClick={this.onMenuItemClick}
                        items={actions}
                    />
                </ScopedPopup>
            </>
        );
    }

    private onActionsSelectorBtnClick = () => {
        this.setState({
            isActionsSelectorOpened: !this.state.isActionsSelectorOpened
        });
    };

    private onActionsSelectorOutsideClick = () => {
        this.setState({ isActionsSelectorOpened: false });
    };

    private onMenuItemClick = (event: React.MouseEvent<HTMLElement>, val: GridAction) => {
        this.setState({ isActionsSelectorOpened: false });

        const action = this.props.actions
            .reduce((res: Array<GridActionItem>, actionsGroup) => [...res, ...actionsGroup.items], [])
            .find(item => item.val === val);

        if (!action) {
            return;
        }

        let linkTarget = action.linkTarget;

        if (!linkTarget) {
            linkTarget = event.ctrlKey || event.metaKey ? LinkTarget.blank : LinkTarget.self;
        }

        if (action.type === GridActionItemType.nav) {
            this.props.onActionClick(action.type, val, linkTarget);
        } else {
            this.props.onActionClick(action.type, val);
        }
    };
}
